import type { HyperlinkProps } from './types'

const Hyperlink = ({ children, href, label, className, disabled, ...rest }: HyperlinkProps) => {
  return (
    <a href={href} className={className} data-disabled={disabled} {...rest}>
      {label || children}
    </a>
  )
}
export default Hyperlink

